module.exports = __webpack_public_path__ + "img/2019qinglongxia-1.2f4fb7f5.jpg";